import { render, staticRenderFns } from "./DetalleValoracionServicios.vue?vue&type=template&id=280652c1"
import script from "./DetalleValoracionServicios.vue?vue&type=script&lang=js"
export * from "./DetalleValoracionServicios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports